<div class="new-modal" (keydown)="keyDownPressed($event)">
  <div class="block-content">
    <div class="icon-close-modal" (click)="dialogRef.close()">
      <img src="./assets/img/icons/invalid-name.svg">
    </div>
    <div class="text-center title-modal text-uppercase title-modal-item">
      {{data.name}}
    </div>
    <div class="message-modal text-center my-1" [innerHtml]="data.body">
    </div>
  </div>

  <div class="float-left block-button">
    <div class="float-left">
      <button mat-raised-button class="primary-button" [mat-dialog-close]="data.okey" tabindex="2">Sim</button>
    </div>
  </div>
</div>
